import { Buffer } from 'buffer'
import { inflate } from 'pako'

import { MedicalId } from '../types'

export const transformV4 = (urlString: string): MedicalId => {
  const url = new URL(urlString)
  const payload = url.searchParams.get('payload') ?? ''
  const decodedBase64 = Buffer.from(payload, 'base64')
  const uint8 = new Uint8Array(decodedBase64)
  const inflatedPayload = inflate(uint8, { to: 'string' })

  const minified = JSON.parse(inflatedPayload) ?? []

  const medicalId: MedicalId = {
    id: minified[0],
    fullName: minified[1],
    dateOfBirth: minified[2],
    gender: minified[3],
    nationality: minified[4],
    languages: minified[5],
    emergencyContacts: minified[6],
    chronicConditions: minified[7],
    pacemaker: minified[8],
    organDonor: minified[9],
    religion: minified[10],
    eyeColor: minified[11],
    systemOfMeasurement: minified[12],
    height: minified[13],
    weight: minified[14],
    identificationCharacteristics: minified[15],
    insuranceCompanyName: minified[16],
    insuranceNumber: minified[17],
    insurancePhoneNumber: minified[18],
    insurancePhoneNumberCountryCode: minified[19],
    passportNumber: minified[20],
    ssn: minified[21],
    linkedResources: minified[22],
  }

  return medicalId
}
